import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CoreService } from '@portal-output/core/services/core.service';
import { first } from 'rxjs';

export const licenseResolver: ResolveFn<number> = () => {
  const coreService = inject(CoreService);

  return coreService.getLicenseId$().pipe(
    first()
  );
};
